var jQuery = require('jquery');
require('jquery.easing');

window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
// require('bootstrap');
require('bootstrap/js/dist/alert');
// require('bootstrap/js/dist/button');
// require('bootstrap/js/dist/carousel');
require('bootstrap/js/dist/util');
// require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
// require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');

require('isotope-layout/dist/isotope.pkgd');
// require('imagesloaded');



// import AOS from 'aos';

// require('aos');
// var AOS = require('aos/dist/aos.js');

require('bootstrap-select');

// const bodymovin = require('lottie-web');
// window.bodymovin = bodymovin;

// require('jquery.placeholder');
// require('jquery-sticky');



require('owl.carousel');
// require('magnific-popup');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded

$(function() {

    // AOS.init({
    //     //options
    // });

    $('.grid').isotope({
      // options
      itemSelector: '.grid-item',
      // layoutMode: 'fitColumns',
      layoutMode: 'masonry',
      masonry: {
            columnWidth: 0,
            gutter: 0
        }
    });


    $('.grid').each(function(){
        var $module = $(this);
        var update = function(){
            $module.isotope('layout'); // fix lazyload overlapping issues
        };
        // Note: Instead of waiting for all images until we initialize the widget
        // we use event capturing to update the widget's layout progressively.
        this.addEventListener('load', update, true);

        $module.isotope();
    });

    if ($("#clients--container").length) {
        //Animate home clients 250px to auto

        var itemClient = $("#clients--container .img-wrap").height()

        var containerHeight = itemClient * 3


        var divh = document.getElementById('clients--container').offsetHeight;
        $("#clients--container").css('height', containerHeight);
        $("#btn-more-clients ").click(function() {
            $("#clients--container").animate({
                height: divh
            }, 0);
        });

        // clients more btn
        $("#btn-more-clients").on('click', function() {
            $("#btn-less-clients").css("display", "inline-flex");
            $("#btn-more-clients").hide();
        });

        $("#btn-less-clients").on('click', function() {
            $("#btn-less-clients").hide();
            $("#btn-more-clients").show();
            $("#clients--container").css('height', containerHeight);
        });

    };


    $(window).on('resize load scroll', function() {
        var headerHeight = $('#header').outerHeight();

        var scroll = $(window).scrollTop();

        if (scroll >= (headerHeight + 50)) {  //scroll top menu out of view 
            $('.header-reveal').addClass("header-reveal--down")
            $('.main-nav').addClass("main-nav--down")
        } else {
            $('.header-reveal').removeClass("header-reveal--down")
            $('.main-nav').removeClass("main-nav--down")
        }


        // Sidebar nav height
        navHeight = $(".header-reveal--down").outerHeight();
        windowHeight = $( window ).height();
        // $headerHeight = $("h1").offset().top;
        navResized = windowHeight - navHeight - 64;


        // if ($windowHeight <= $navHeight ) {
            $('.sticky-top').css('height', navResized  )
            // $('.sticky-top').css('height', $navResized   )
        // }

        var windowHeight = $(document).height()
        var position;
        position = navHeight;

        if ($(window).scrollTop() > position) {
            $(".sticky-top").css('overflow-y', 'scroll')
        } else {
            $(".sticky-top").css('overflow-y', 'initial')
        }


    });


    $(window).on('load resize scroll', function() {

         // offSetContent();

         var revealSpacerHeight = $(".reveal-wrapper").outerHeight();

         $(".reveal-spacer").css("height", revealSpacerHeight )


        // var revealWrapperHeight = $(".reveal-wrapper").outherHeight();
        // var footerHeight = $('#footer').outerHeight();

        // $(".reveal-wrapper").css("height", footerHeight + "px");



        // $(".reveal-wrapper").css("margin-bottom", footerHeight + "px");
        // $(".reveal-wrapper-spacer").css("margin-top", footerHeight + "px");
        // $(".body").css("padding-bottom", footerHeight + "px");

        // $('#floating-nav').css("bottom", footerHeight);


        if ($(window).width() <= 500) {

            $(".img-move--container").each(function() {
                var windowTop = $(window).scrollTop();
                var elementTop = $(this).offset().top;
                var containerWidth = $(".img-move--container").outerWidth;
                var rightPosition = windowTop - elementTop - 0;
                // var rightPosition = containerWidth - elementTop;

                // if(elementTop < 300) {

                $(this)
                    .find(".img-move--item")
                    .css({
                        left: -rightPosition - 375
                    });
                // }else{
                // alert('bingo');
                // }
            });

        } else {
            $(".img-move--item").css("left", "auto");
        }



        if ($(window).width() <= 1440) {
            $(".owl-carousel--phone-6").owlCarousel({
                margin: 24,
                nav: false,
                dots: false,
                loop: true,
                autoplay: false,
                smartSpeed: 1000,
                autoplayTimeout: 3000,

                responsive: {
                    0: {
                        items: 1,
                    },
                    768: {
                        items: 2,
                    },
                    1200: {
                        items: 3,
                    }
                }

            });
        } else {
            // $(".phone-carousel").destroy();
            // $(".phone-carousel").data("owlCarousel").destroy();
            stopCarousel();
        }


        if ($(window).width() <= 991) {
            $(".owl-carousel--phone-3").owlCarousel({
                margin: 0,
                nav: false,
                dots: false,
                loop: true,
                autoplay: true,
                smartSpeed: 1000,
                autoplayTimeout: 3000,

                responsive: {
                    0: {
                        items: 1,
                    },
                    576: {
                        items: 2,
                    },
                    768: {
                        items: 3,
                    }
                }

            });
        } else {
            // $(".phone-carousel").destroy();
            // $(".phone-carousel").data("owlCarousel").destroy();
            stopCarousel();
        }


        if ($(".testimonial-carousel").length) {
            $(".testimonial-carousel")
                .on("initialized.owl.carousel changed.owl.carousel", function(e) {
                    if (!e.namespace) {
                        return;
                    }
                    $("#owl-counter").text(
                        e.relatedTarget.relative(e.item.index) + 1 + " of " + e.item.count
                    );
                })
                .owlCarousel({
                    margin: 0,
                    nav: false,
                    dots: false,
                    loop: true,
                    autoplay: false,
                    smartSpeed: 1000,
                    autoplayTimeout: 6000,
                    items: 1,
                    navText: [, ],
                    responsive: {
                        768: {
                            nav: true,
                        }
                    }
                });
        }

        $(".owl-carousel-testimonial-grey").owlCarousel({
                margin: 0,
                nav: false,
                dots: false,
                loop: true,
                autoplay: true,
                smartSpeed: 1000,
                autoplayTimeout: 6000,
                items:1,
            });

        $(".image-carousel").owlCarousel({
                margin: 10,
                nav: false,
                dots: false,
                loop: false,
                autoplay: false,
                smartSpeed: 1000,
                autoplayTimeout: 6000,
                items:3,
                autoWidth:true,
                center:false,
                // stagePadding: 150,
                onDragged: callback,
            });

        function callback(event) {
            $(".image-carousel").owlCarousel({

                
            });
        }

    });

    function stopCarousel() {
        var owl = $('.owl-carousel--phone-6');
        owl.trigger('destroy.owl.carousel');
        owl.addClass('off');
    }


    $(".tab-pane.active #name").focus();

    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
        $(".tab-pane.active #name").focus();
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
            $(".tab-pane.active #name").focus();
        } else {

        }
    });


    // Page scroll
    $('.page-scroll').bind('click', function(event) {
        var $anchor = $(this);
        var elId = $anchor.attr('href').replace('/', '');

        $('html, body').stop().animate({
            scrollTop: $(elId).offset().top
        }, 750, 'easeInOutExpo');

        event.preventDefault();
    });



    // $(window).scroll(function() {

    //     var windowHeight = $(document).height() - 1700
    //     var position;
    //     position = windowHeight;
    //     if ($(window).scrollTop() > position) {
    //         return $("#sticky-sidebar-nav").unstick();
    //     } else {
    //         return $("#sticky-sidebar-nav").sticky({
    //             topSpacing: 126,
    //             zIndex: 300
    //         });
    //     }
    // });


    // $('#floating-nav').sticky({
    //     topSpacing: 'auto',
    //     bottomSpacing: 300,
    //     getWidthFrom: '#floating-nav',
    //     getHeightFrom: '#floating-nav',

    // });


    // console.log($navHeight)


    $('.btn-nav').on('click', function() {
        $('#main-nav').toggleClass('active');
        // $('#main-nav .nav-link').toggleClass('animated');
        // $('#main-nav .nav-item').toggleClass('opacity1');
        $('#main-nav .icon').toggleClass('animated');

        // $('.logo-container').toggleClass('bg-primary');
        $('#main-nav .nav-item').css("transition-delay", ".2s");

        //add padding to main-nav
        var headingPaddingTop = $('.header-wrapper').css('padding-top');

        $(".main-nav").css("padding-top", headingPaddingTop).css('transition', 0)
    });


    $("#main-nav .navbar-nav").hover(function() {
        $(this).addClass("hover-speed");
    }, function() {
        $(this).removeClass("hover-speed");
    })


    $(window).scroll(function() {

        var scroll = $(window).scrollTop();


        if ($('.hero-container').length) {

            var heroHeight = $('.hero-container').outerHeight();


            if (scroll >= heroHeight) { /* scroll top menu out of view */

                // $('.hero-container').css('z-index', -1)
                // $('#footer').css('z-index', 0)

            } else {

                // $('.hero-container').css('z-index', 0)
                // $('#footer').css('z-index', -1)

            }
        }

        //hide gmap until 900px so its not visible on mobile header
        // if (scroll < 900) {
        //     $('.gmap-wrapper').css('z-index', -1).css('opacity', 0)

        // } else {

        //     $('.gmap-wrapper').css('z-index', 0).css('opacity', 1)
        // }


    });



    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }


    $('.selectpicker').selectpicker();


    if ($('.page-scroll').length) {
        // Page scroll
        $('.page-scroll').bind('click', function(event) {
            var $anchor = $(this);

            var headerHeight = $('#header').outerHeight();

            $('html, body').stop().animate({
                scrollTop: $($anchor.attr('href')).offset().top - headerHeight + 60
            }, 750, 'easeInOutExpo');

            event.preventDefault();
        });
    }

    scrollToFormError();

});




function scrollToFormError() {
    // console.log('scrollToFormError', window.location.hash);
    var windowWidth = $(window).width();
    var formStr = '#form-';
    // enquiry form error anchor offset
    if (window.location.hash && window.location.hash.indexOf(formStr) != -1) {

        var formEl = window.location.hash;
        if ($(formEl).length > 0) {

            // var offsetSize = $('.headerfixed').height();
            // console.log(window.location.hash+' '+offsetSize +' '+$(formEl).scrollTop());

            var offsetSize = $('#main-nav').height() + 50;
            if (windowWidth > 767) {
                // offset
                // animate scrollto
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            } else {
                $('html, body').animate({ scrollTop: $(formEl).offset().top - offsetSize }, 1000);
            }

        }
    }
}



function offSetContent() {
    // offset about section from top of browser

    var headerHeight = $('#header').outerHeight();

    var heroHeight = $('.hero-container').outerHeight();
    // var headerSpacer = $('.header-spacer').outerHeight();



    // var fullHeight = $(window).height();
    var fullHeight = heroHeight - headerHeight;

    // returns width of browser viewport
    //if( $(window).width() > 767) {
    if ($('.hero-container').css('position') == 'absolute') {
        $('#hero-offset').css('margin-top', fullHeight + 'px');
    } else {
        $('#hero-offset').css('margin-top', '0px');
    }
}




//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {

    // Infinite Ajax Scroll
}


// WEBPACK FOOTER //
// ./resources/assets/site/js/init.js